$(document).ready(function(){
    if($('#search-personnel').length){
        $('#search-personnel').fastLiveFilter('#personnel-list');
    }
    if($('#search-programs').length){
        $('#search-programs').fastLiveFilter('#academics-link-list');
    }
    if($('#search-programs-updated').length){
        $('#search-programs-updated').fastLiveFilter('.academics-link-list-children');
    }
    if($('#search_input_counselors_3').length){
        $('#search_input_counselors_3').fastLiveFilter('#myCounselors_3');
    }
    if($('#search_input_counselors_4').length){
        $('#search_input_counselors_4').fastLiveFilter('#myCounselors_4');
    }
    if($('#search-timeline').length){
        $('#search-timeline').fastLiveFilter('.timeline');
    }
});